import React, {useEffect, useState} from "react";
import { useForm, Controller } from "react-hook-form";
import { Trans, useTranslation } from "react-i18next";
import Style from "../tickets.module.scss";
import LabelWithHR from "../../common/label/labelWithHR";
import Button from "../../common/button/button";
import Navbar from "../../reusable/navbar";
import HeadingLabelDesktop from "../../common/label/headingLabelDesktop";
import {CountryCode} from "../../reducers/ticket";
import { useContext } from "react";
import { TicketDetailsContext } from '../../components/TicketDetailsContext';


export function TicketsDesktop({
  enterReferenceAndLicensePlate,
  setTicket,
  ticket,
  error,
  setError,
  shouldDisable,
  version,
}) {
  const { handleSubmit, control, formState : { errors }} = useForm(
      {
        mode: "onTouched",
        reValidateMode: "onChange",
        defaultValues: {
          reference: ticket.number,
          licensePlate: ticket.licensePlate,
        },
      }
  );
  const { t } = useTranslation();

  // Detect market based on hostname
  const { market } = useContext(TicketDetailsContext);

  return (
    <div className={Style.mainContainerDesktop}>
      <Navbar />
      <div className={Style.formDesktop}>
        <HeadingLabelDesktop />
        <p className={Style.formDesktop__paragraphStyle}>
          <span>{t("Tickets.Fill the fields below", { context: market }).toString()}</span>
          <br />
          <span dangerouslySetInnerHTML={{ __html: t("Tickets.dataProtectionText", { context: market }) }} />
        </p>
        <div className={Style.formDesktop__ticketForm}>
          <form
            onSubmit={handleSubmit((data) => {
              const normalizedLicensePlate = ticket.licensePlate
                .toUpperCase()
                .replace(/[^A-Z0-9ÄÖÜß]/gi, "");
              enterReferenceAndLicensePlate({
                ...data,
                licensePlate: normalizedLicensePlate,
              });
              setTicket({ ...ticket, licensePlate: normalizedLicensePlate });
            })}
          >
            <LabelWithHR label={t("Tickets.Reference")} />
            <Controller
              name="reference"
              defaultValue=""
              control={control}
              render={() => (
                <input
                  type={"number"}
                  placeholder="123456789"
                  className={Style.input}
                  name="reference"
                  defaultValue={ticket.number}
                  onChange={(e) => {
                    setError("");
                    if (e.target.value.includes(" ")) {
                      return;
                    }

                    setTicket({ ...ticket, number: e.target.value });
                  }}
                />
              )}
            />
            <LabelWithHR label={t("Tickets.License plate", { context: market })} />
            <Controller
              name="licensePlate"
              defaultValue=""
              control={control}
              render={({ field,}) => (
                <input
                  type={"text"}
                  style={{
                    textTransform: "uppercase",
                  }}
                  className={Style.input}
                  placeholder={t("Tickets.License plate placeholder", { context: market })}
                  name="licensePlate"
                  defaultValue={ticket.licensePlate}
                  onChange={(e) => {
                    field.onChange(e.target.value.toUpperCase());
                    setError("");
                    setTicket({ ...ticket, licensePlate: e.target.value });
                  }}
                  onBlur={field.onBlur}
                />
              )}
            />

            {error && (
              <div
                className={Style.errorMessage}
                onClick={() => {
                  setError("");
                }}
              >
                {error}
              </div>
            )}

            <Button
              classNameWrapper={Style.buttonDesktopLeft}
              text={t("Tickets.Further")}
              disabled={shouldDisable()}
            />
          </form>
        </div>
      </div>
      <div className={Style.versionBox}>VERSION:{version}</div>
    </div>
  );
}
